import * as angular from 'angular';
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import { apsCommands } from "../../shared/dto/aps.commands";
import { apsEnums } from "../../shared/dto/aps.enums";
import HttpServiceName, { HttpService } from "../http/http.service";
import { Endpoints } from "../../shared/config/constant.module";

export interface EquipmentService {
  get(plantId: string): angular.IPromise<apsViewModels.EquipmentDetail[]>;
  getScales(plantId: string, shopId: string): angular.IPromise<apsViewModels.EquipmentDetail[]>;
  add(command: apsCommands.AddEquipment): angular.IPromise<any>;
  updateConfig(command: apsCommands.UpdateEquipmentConfig): angular.IPromise<any>;
  setScaleMode(command: apsCommands.UpdateScaleMode): angular.IPromise<any>;
  activate(command: apsCommands.ActivateEquipment): angular.IPromise<any>;
  disable(command: apsCommands.DisableEquipment): angular.IPromise<any>;
  remove(command: apsCommands.RemoveEquipment): angular.IPromise<any>;
  getValidLocationTypes(equipmentType: apsEnums.EquipmentType): apsEnums.LocationType[];
  getShop(shopId: string): angular.IPromise<apsViewModels.EquipmentDetail[]>;
  getLineEquipmentType(equipmentType: apsEnums.EquipmentType): apsEnums.LineEquipmentType;
}

class EquipmentSvc implements EquipmentService {
  private httpService: HttpService;

  constructor(httpService: HttpService) {
    this.httpService = httpService;
  }

  get(plantId: string): angular.IPromise<apsViewModels.EquipmentDetail[]> {
    return this.httpService.get<apsViewModels.EquipmentDetail[]>(Endpoints.EQUIPMENT, { plantId: plantId });
  }

  getScales(plantId: string, shopId: string): angular.IPromise<apsViewModels.EquipmentDetail[]> {
    return this.httpService.get<apsViewModels.EquipmentDetail[]>(Endpoints.SCALES, {
      plantId: plantId,
      shopId: shopId
    });
  }

  add(command: apsCommands.AddEquipment): angular.IPromise<any> {
    return this.httpService.post(Endpoints.EQUIPMENT, command);
  }

  updateConfig(command: apsCommands.UpdateEquipmentConfig): angular.IPromise<any> {
    return this.httpService.put(Endpoints.EQUIPMENT, command);
  }

  setScaleMode(command: apsCommands.UpdateScaleMode): angular.IPromise<any> {
    return this.httpService.put(Endpoints.SCALE_MODE, command);
  }

  activate(command: apsCommands.ActivateEquipment): angular.IPromise<any> {
    return this.httpService.put(Endpoints.EQUIPMENT_ACTIVATE, command);
  }

  disable(command: apsCommands.DisableEquipment): angular.IPromise<any> {
    return this.httpService.put(Endpoints.EQUIPMENT_DISABLE, command);
  }

  remove(command: apsCommands.RemoveEquipment): angular.IPromise<any> {
    return this.httpService.delete(Endpoints.EQUIPMENT + '/' + command.id,
      { plantId: command.plantId });
  }

  getValidLocationTypes(equipmentType: apsEnums.EquipmentType): apsEnums.LocationType[] {
    switch (equipmentType) {
      case apsEnums.EquipmentType.SerialConverter:
        return [apsEnums.LocationType.Plant];
      case apsEnums.EquipmentType.Scale:
      case apsEnums.EquipmentType.WSI:
      case apsEnums.EquipmentType.WBF:
      case apsEnums.EquipmentType.HEYE:
      case apsEnums.EquipmentType.CheckDetector:
      case apsEnums.EquipmentType.CBIT:
      case apsEnums.EquipmentType.Cyclops:
        return [apsEnums.LocationType.Shop];
      case apsEnums.EquipmentType.PLC:
      case apsEnums.EquipmentType.AIServer:
      case apsEnums.EquipmentType.RaspberryPi:
      case apsEnums.EquipmentType.MX4:
      case apsEnums.EquipmentType.Multi:
      case apsEnums.EquipmentType.Mcal:
      case apsEnums.EquipmentType.FlexBC:
      case apsEnums.EquipmentType.FlexM:
      case apsEnums.EquipmentType.FlexIS:
      case apsEnums.EquipmentType.LineServer:
      case apsEnums.EquipmentType.KepC:
      case apsEnums.EquipmentType.SqlC:
      case apsEnums.EquipmentType.PPCScale:
      case apsEnums.EquipmentType.SqlM:
      case apsEnums.EquipmentType.WSG:
      case apsEnums.EquipmentType.WFG:
  return [
          apsEnums.LocationType.Plant,
          apsEnums.LocationType.Tank,
          apsEnums.LocationType.Shop,
          apsEnums.LocationType.Other,
        ];
    }
    return [];
  }

  getLineEquipmentType(equipmentType: apsEnums.EquipmentType): apsEnums.LineEquipmentType {
    switch (equipmentType) {
      case apsEnums.EquipmentType.WSI:
        return apsEnums.LineEquipmentType.WSI;
      case apsEnums.EquipmentType.WBF:
        return apsEnums.LineEquipmentType.WBF;
      case apsEnums.EquipmentType.HEYE:
        return apsEnums.LineEquipmentType.HEYE;
      case apsEnums.EquipmentType.CheckDetector:
        return apsEnums.LineEquipmentType.CheckDetector;
      case apsEnums.EquipmentType.MX4:
        return apsEnums.LineEquipmentType.MX4;
      case apsEnums.EquipmentType.Multi:
        return apsEnums.LineEquipmentType.Multi;
      case apsEnums.EquipmentType.Mcal:
        return apsEnums.LineEquipmentType.Mcal;
      case apsEnums.EquipmentType.FlexBC:
        return apsEnums.LineEquipmentType.FlexBC;
      case apsEnums.EquipmentType.FlexM:
        return apsEnums.LineEquipmentType.FlexM;
      case apsEnums.EquipmentType.FlexIS:
          return apsEnums.LineEquipmentType.FlexIS;      
      default:
        
        return null;
    }
  }

  getShop(shopId: string): angular.IPromise<apsViewModels.EquipmentDetail[]> {
    return this.httpService.get<apsViewModels.EquipmentDetail[]>(Endpoints.EQUIPMENT_SHOP, { shopId: shopId });
  }
}

export default angular
  .module('aps.services.equipment', [HttpServiceName])
  .service('equipmentService', EquipmentSvc)
  .name;


// WEBPACK FOOTER //
// ./src/app/services/equipment/equipment.service.ts